import { z } from 'zod';

export enum ShapeType {
  CIRCLE = 'circle',
  RECTANGLE = 'rectangle',
  TABLE = 'table',
}

export const ShapeSchema = z.object({
  type: z.nativeEnum(ShapeType),
  width: z.number(),
  height: z.number(),
  color: z.string(),
});

export const SHAPE_DEFAULT_WIDTH = 50;
export const SHAPE_DEFAULT_HEIGHT = 50;
